import type { ModalFuncProps } from 'ant-design-vue'

import { Modal } from 'ant-design-vue'

const methods = ['confirm', 'info', 'error', 'warning', 'success']
// 默认配置
const defaultOptions: ModalFuncProps = {
  cancelText: '取消',
  centered: true,
  maskClosable: false,
  okText: '确定',
}

// 为每个方法创建对应的函数
export const modal = methods.reduce(
  (acc, method) => {
    acc[method] = (options: ModalFuncProps) => {
      return Modal[method]({
        ...defaultOptions,
        ...options,
      })
    }
    return acc
  },
  {} as typeof Modal,
)
